import React, { useState, useCallback } from 'react';
import { LoginPage } from './LoginPage';

export function AuthGate({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem('sa-sre-auth') === 'true',
  );

  const handleLogin = useCallback(
    (username: string, password: string): boolean => {
      if (username === 'knowcom' && password === 'knowcom7056') {
        sessionStorage.setItem('sa-sre-auth', 'true');
        setIsAuthenticated(true);
        return true;
      }
      return false;
    },
    [],
  );

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return <>{children}</>;
}
